/** Em dash used as a placeholder when data is not available */
export const NO_DATA = '—';
